module.exports = [
    '$analytics', 
    '$uibModal', 
    annotationsModal
];

function annotationsModal(
    $analytics, 
    $uibModal
) {

    var modal = {
        section: null,
        chapter: null,
        subchapter: null,
        show: showModal
    };

    annotationsModalController.$inject = [
        '$q', 
        '$uibModalInstance', 
        'annotationsDataService', 
        'common',
        'section', 
        'chapter',
        'subchapter',
    ];

    function annotationsModalController(
        $q, 
        $uibModalInstance, 
        annotationsDataService, 
        common,
        section, 
        chapter,
        subchapter
    ) {
        
        var vm = {
            $onInit: attached,
            cancel: cancel,
            section: section,
            chapter: chapter,
            subchapter: subchapter,
            clickNavItem: clickNavItem,
            scrollToItemByXpath: scrollToItemByXpath,
        };

        function attached() {
            vm.isLoading = true;
            var promises = [];
            if (subchapter) {
                
                promises.push(annotationsDataService
                    .getSubchapterNote(subchapter)
                    .then(function(note) {
                        if (note) {
                            vm.subchapterNote = note;
                            
                            if (subchapter.length === 4) {
                                // substr because the subchapter is formatted like a heading (e.g. 9903 for subchapter 3 of chapter 99 ) in the US trade tariff
                                vm.subchapterNav = {
                                    number: common.formatting.numberToRoman(subchapter.substr(2, 2)),
                                    class: 'subchapter-' + subchapter,
                                    selector: '.subchapter-' + subchapter
                                };
                            }
                            else {
                                vm.subchapterNav = {
                                    romanNumeral: common.formatting.numberToRoman(subchapter),
                                    selector: '.subchapter-' + subchapter
                                };
                            }
                        }
                    }));
            }
            if (chapter) {
                promises.push(annotationsDataService
                    .getChapterNote(chapter)
                    .then(function(note) {
                        if (note) {
                            vm.chapterNote = note;
                            
                            vm.chapterNav = {
                                number: chapter,
                                class: 'chapter-' + chapter,
                                selector: '.chapter-' + chapter
                            };
                        }
                    }));
            }
            if (section) {
                promises.push(annotationsDataService
                    .getSectionNote(section)
                    .then(function(note) {
                        if (note) {
                            vm.sectionNote = note;
                            
                            vm.sectionNav = {
                                number: common.formatting.numberToRoman(section),
                                class: 'section-' + section,
                                selector: '.section-' + section
                            };
                        }
                    }));
            }
            return $q.all(promises)
                .then(function() {
                    vm.isLoading = false;
                });
        }

        function clickNavItem(item) {
            // console.log(item);
            document.querySelector(item.selector).scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        function scrollToItemByXpath(xpath, noteId) {
            var contextNode = document.querySelector(noteId + ' .note-html');
            var targetNode = document.evaluate(xpath, contextNode, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
            if (targetNode) {
                targetNode.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            else {
                // console.log('XPath not found: ' + xpath);
            }
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        return vm;
    }

    function showModal(section, chapter, subchapter) {
        $analytics.eventTrack('open-modal-legal-notes', { category: 'legal-notes' });
        return $uibModal.open({
            animation: true,
            backdrop: true,
            bindToController: true,
            controller: annotationsModalController,
            controllerAs: 'ctrl',
            keyboard: true,
            modalFade: true,
            resolve: {
                section: function() {
                    return section;
                },
                chapter: function() {
                    return chapter;
                },
                subchapter: function() {
                    return subchapter;
                },
            },
            size: 'lg',
            templateUrl: 'texts/modals/annotations.html',
            windowClass: 'modal-wide'
        }).result.catch(function (res) {
            if (!(res === 'cancel' || res === 'escape key press' || res === 'backdrop click')) {
                throw res;
            }
        });
    }

    return modal;
}
